// src/services/settings.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const settingsApi = createApi({
  reducerPath: "settings",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/settings/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSettings: builder.query({
      query: () => "gen-app-settings",
    }),
  }),
});

export const { useGetSettingsQuery } = settingsApi;
export default settingsApi;
export { settingsApi };
